export default "__VITE_ASSET__Bc2axr4G__"